import { render, staticRenderFns } from "./warehouseAccessUserIcon.vue?vue&type=template&id=2ea28acc&scoped=true"
import script from "./warehouseAccessUserIcon.vue?vue&type=script&lang=js"
export * from "./warehouseAccessUserIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea28acc",
  null
  
)

export default component.exports